import { defineComponent, Component, toRef } from 'vue';
import { SearchUserDto } from '@studyportals/campaign-management-api-interface';
import SearchDropdownItem from '@/presentation/components/rights/rights-search/search-dropdown-item/search-dropdown-item.vue';
import Spinner from '@/presentation/components/shared/spinner/spinner.vue';

export default defineComponent({
	props: {
		searchTerm: {
			type: String,
			required: true
		},
		items: {
			type: Array,
			required: true
		},
		showSpinner: {
			type: Boolean,
			required: true
		}
	},
	components: {
		SearchDropdownItem: SearchDropdownItem as Component,
		Spinner: Spinner as Component
	},
	setup: (props) => {
		const searchTerm = toRef(props, 'searchTerm');

		return {
			searchTerm,
			items: props.items as SearchUserDto[]
		};
	}
});
